import React from "react";

function Facebook({ fb }) {
  if(fb.length>0){
    return (
      <div className="px-2">
        <h3 className="mx-2 my-4">Facebook Posts</h3>
        {fb.map(fbk => {
          return (
            <>
            <div className="d-flex" key={fbk.link}>
              <div className="d-flex"><i className="fab fa-facebook text-6xl text-primary mr-3" style={{fontSize:80}}></i></div>
              <div className="ml-sm-3">
                <p className="font-bold"><i className="fas fa-user"></i> {fbk.header}</p>
                <p className="font-bold small"><i className="far fa-clock"></i> {fbk.date}</p>
                <p className="">{fbk.text}</p>
                <div className="d-flex my-1 small">
                  <p className=""><i className="text-primary fas fa-thumbs-up"></i> {fbk.likes}</p>
                  <p className="mx-2"><i className="text-secondary-500 far fa-comment"></i> {fbk.comments}</p>
                </div>
              </div>
            </div>
            <hr className="bg-dark my-1 my-sm-3 w-100"></hr>
            </>
          )
        })}
      </div>
    )
  }else{
    return ""
  }
}

export function Twitter({ tweet }) {
  if (tweet !== "") {
    return (
      <div className="px-2">
        <h3 className="my-4">Twitter Posts</h3>
        {tweet.map((data, index) => {
          return (
            <>
            <div key={index} className="row mb-2">
              <div className="col-3 col-sm-1 d-flex">
                <i className="fab fa-twitter text-primary" style={{fontSize:80}} color="blue"></i>
              </div>
              <div className="col-9 col-sm-11">
                <small className="text-secondary"><i className="far fa-clock"></i> {data.date.replace()}</small>
                <p>{data.text}</p>
              </div>
            </div>
            <hr className="bg-dark my-1 my-sm-3"></hr>
            </>
          );
        })}
      </div>
    );
  } else {
    return "";
  }
}

function SocialMedia({ tweet, fb }) {
  return (
    <div className="bg-light py-2 px-sm-3 px-3">
      <Twitter tweet={tweet} fb={fb} />
      <Facebook fb={fb} />
    </div>
  );
}

export default SocialMedia;
